export default "__VITE_ASSET__e1be40ee__"